import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getSurfaceBorder, getSurfaceColor, getThemeTokens } from '../tokens';

export const styledBackstageTableHeader = (
  theme: Theme,
): BackstageOverrides['BackstageTableHeader'] => {
  const tokens = getThemeTokens(theme);

  return {
    header: {
      backgroundColor: getSurfaceColor(theme, 'subtle'),
      borderBottom: `1px solid ${getSurfaceBorder(theme)}`,
      color: tokens.textPrimary,
      fontSize: theme.typography.caption.fontSize,
      fontWeight: 700,
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
    },
  };
};
